(() => {
  const initialize = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const track = root.querySelector('[data-product-grid]');

    if (track) {
      let dragging = false;
      let moved = false;
      let suppressClick = false;
      let suppressClickTimer;
      let startX = 0;
      let startScroll = 0;
      let autoScrollFrame;
      let autoScrollStopped = false;
      let lastAutoScrollTime;

      const stopAutoScroll = () => {
        autoScrollStopped = true;
        track.classList.remove('is-auto-scrolling');
        if (autoScrollFrame) window.cancelAnimationFrame(autoScrollFrame);
      };

      const autoScroll = (time) => {
        if (autoScrollStopped) return;
        if (!window.matchMedia('(max-width: 749px)').matches) {
          track.classList.remove('is-auto-scrolling');
          return;
        }

        track.classList.add('is-auto-scrolling');
        if (lastAutoScrollTime) {
          const elapsed = Math.min(time - lastAutoScrollTime, 50);
          track.scrollLeft += elapsed * .018;
        }
        lastAutoScrollTime = time;

        if (track.scrollLeft + track.clientWidth < track.scrollWidth - 2) {
          autoScrollFrame = window.requestAnimationFrame(autoScroll);
        } else {
          track.classList.remove('is-auto-scrolling');
        }
      };

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setTimeout(() => {
          if (!autoScrollStopped) autoScrollFrame = window.requestAnimationFrame(autoScroll);
        }, 900);
      }

      track.addEventListener('pointerdown', (event) => {
        stopAutoScroll();
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5 && !moved) {
          moved = true;
          track.setPointerCapture(event.pointerId);
        }
        track.scrollLeft = startScroll - distance;
      });

      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        window.clearTimeout(suppressClickTimer);
        suppressClick = moved;
        suppressClickTimer = window.setTimeout(() => {
          suppressClick = false;
          moved = false;
        }, 0);
      };

      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
      track.addEventListener('touchstart', stopAutoScroll, { passive: true });
      track.addEventListener('wheel', stopAutoScroll, { passive: true });
      track.addEventListener('keydown', stopAutoScroll);
      track.addEventListener('dragstart', (event) => event.preventDefault());
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        moved = false;
      }, true);
    }

  };

  document.querySelectorAll('[data-dorimo-home]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-dorimo-home]')));
})();
